import { atom, useRecoilValue } from 'recoil'
export type AppAlertMessageStoreType = {
    isOpen: boolean
    title: string
    message: string
}
export const appAlertMessageStore = atom<AppAlertMessageStoreType>({
    key: 'appAlertMessageStore',
    default: {
        isOpen: false,
        title: '',
        message: '',
    },
})

const useAppAlertMessageStore = () => {
    const appAlertMessageState = useRecoilValue(appAlertMessageStore)
    return {
        ...appAlertMessageState,
    }
}

export default useAppAlertMessageStore
